import { useTranslation } from 'react-i18next';
import { Button, HeartFillIcon, HeartLineIcon } from 'ui';

type P = { count: number; isLiked: boolean; isLoading: boolean; onClickLike: () => void };

const LikeButton = ({ count, isLiked, isLoading, onClickLike }: P) => {
  const { t } = useTranslation();

  return (
    <Button
      danger={isLiked}
      icon={isLiked ? <HeartFillIcon /> : <HeartLineIcon />}
      loading={isLoading}
      onClick={onClickLike}
      type="link-secondary"
    >
      {t('likesCount', { count })}
    </Button>
  );
};

export default LikeButton;
